import { render, staticRenderFns } from "./TeamSetting.vue?vue&type=template&id=4075d80a&scoped=true"
import script from "./TeamSetting.vue?vue&type=script&lang=js"
export * from "./TeamSetting.vue?vue&type=script&lang=js"
import style0 from "./TeamSetting.vue?vue&type=style&index=0&id=4075d80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075d80a",
  null
  
)

export default component.exports